<template>
    <p>
        <img src="https://img.kakaclo.com/web-img/index/Group%202174.png" style="width:12px;height:14px;margin-right:4px">
        {{ $t('Index.Components.CarFlashTime.EndIn') }}
        {{ getEndTimeFormat}}
    </p>
</template>

<script>
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
dayjs.extend(utc)
dayjs.extend(timezone)

export default {
  props: {
    // 截止时间时间戳（毫秒）
    endTime: {
      type: Number,
      require: true,
      default: 0
    }
  },
  data() {
    return {
      day: 0,
      time: '0000',
      hours: '00'
    }
  },
  computed: {
    getEndTimeFormat() {
      return `${this.hours}:${this.time[0]}${this.time[1]}:${this.time[2]}${this.time[3]}`
    }
  },
  created() {
    const timer = setInterval(() => {
      const current = new Date().getTime()
      const time = this.endTime - current
      if (time <= 0) {
        this.day = 0
        this.time = '0000'
        return clearInterval(timer)
      }
      const day = parseInt(dayjs.tz(time, 'GMT').format('DD')) - 1
      const timeStr = dayjs.tz(time, 'GMT').format('HHmmss')
      let hours = String(parseInt(timeStr.slice(0, 2)) + day * 24)
      if (hours.length === 1) hours = '0' + hours
      this.hours = hours
      this.time = timeStr.slice(2)
    }, 1000)

    this.$once('hook:beforeDestroy', () => {
      clearInterval(timer)
    })
  }
}
</script>
